import React from 'react';
import { colorPalette, Typography } from '@rakutenfrance/mui';
import { Cart } from '@rakutenfrance/shared-svg';
import { s, P as PriceClub, M as Membership } from './Membership-da17af45.js';
import { useTranslate, useMarketplace } from '@rakutenfrance/tolgee-provider';
import { c as canopyStyle, t as tooltipStyle } from './index-498751b0.js';
import 'debug';
import 'tslib';
import 'graphql-tag';
import 'react-autosuggest';
import '@mui/material/Card';
import '@mui/material/CardContent';
import '@mui/material/Skeleton';
import '@rakutenfrance/shared-util';
import 'set-cookie-parser';
import 'cookie';
import 'react-transition-group';
import '@mui/material/Link';
import '@apollo/client';
import '@mui/material/Badge';
import '@rakutenfrance/gtm-provider';
import '@rakutenfrance/shared-component';
import 'react-redux';
import '@rakutenfrance/breakpoint';
import '@rakutenfrance/config-service';

var EmptyCart = function (_a) {
    var _b = _a.priceClubVisible, priceClubVisible = _b === void 0 ? false : _b, _c = _a.isSubscribed, isSubscribed = _c === void 0 ? false : _c;
    var t = useTranslate('header').t;
    var isInTargetMarkets = useMarketplace(['fr']).isInTargetMarkets;
    var shouldShowPriceClub = isInTargetMarkets && priceClubVisible;
    var shouldShowMembership = isInTargetMarkets && !isSubscribed;
    return (React.createElement("div", { className: "".concat(canopyStyle['dark-gray'], " ").concat(s.content, " ").concat(tooltipStyle.wrapper, " ").concat(tooltipStyle['wrapper-default']) },
        React.createElement("div", { className: "".concat(canopyStyle.flex, " ").concat(canopyStyle['items-center'], " ").concat(canopyStyle['justify-center'], " ").concat(s.statusWrapper, " ").concat(canopyStyle['pb3']) },
            React.createElement(Cart, { height: '20', width: '20', fill: colorPalette.gray500 }),
            React.createElement(Typography, { variant: "body-default-regular" }, t('cart_tooltip_empty_label'))),
        shouldShowPriceClub && React.createElement(PriceClub, null),
        !shouldShowMembership && React.createElement(Membership, null)));
};

export { EmptyCart as default };
